import React from 'react';
import { Link } from 'react-router-dom';

// Mirrors WordPress paginate_links() output: end_size 1, mid_size 2,
// "← Prev" / "Next →" labels and "…" gaps.
const buildPageItems = (current, total) => {
    const END_SIZE = 1;
    const MID_SIZE = 2;
    const items = [];
    let dots = false;

    for (let n = 1; n <= total; n += 1) {
        const isEdge = n <= END_SIZE || n > total - END_SIZE;
        const isMid = Math.abs(n - current) <= MID_SIZE;

        if (n === current) {
            items.push({ type: 'current', page: n });
            dots = true;
        } else if (isEdge || isMid) {
            items.push({ type: 'page', page: n });
            dots = true;
        } else if (dots) {
            items.push({ type: 'dots' });
            dots = false;
        }
    }

    return items;
};

function Pagination({ currentPage, totalPages, getPageLink, ariaLabel = 'Posts pagination' }) {
    if (!totalPages || totalPages <= 1) {
        return null;
    }

    const items = buildPageItems(currentPage, totalPages);

    return (
        <nav className="navigation pagination" aria-label={ariaLabel}>
            <h2 className="screen-reader-text">{ariaLabel}</h2>
            <div className="nav-links">
                {currentPage > 1 && (
                    <Link className="prev page-numbers" to={getPageLink(currentPage - 1)}>
                        ← Prev
                    </Link>
                )}
                {items.map((item, index) => {
                    if (item.type === 'dots') {
                        return (
                            <span key={`dots-${index}`} className="page-numbers dots">…</span>
                        );
                    }
                    if (item.type === 'current') {
                        return (
                            <span
                                key={item.page}
                                aria-current="page"
                                className="page-numbers current"
                            >
                                {item.page}
                            </span>
                        );
                    }
                    return (
                        <Link key={item.page} className="page-numbers" to={getPageLink(item.page)}>
                            {item.page}
                        </Link>
                    );
                })}
                {currentPage < totalPages && (
                    <Link className="next page-numbers" to={getPageLink(currentPage + 1)}>
                        Next →
                    </Link>
                )}
            </div>
        </nav>
    );
}

export default Pagination;
